import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationsState } from './reducers/notifications.reducer';

export const notificationsStateKey = 'notifications';

const selectNotificationsFeature = createFeatureSelector<NotificationsState>(notificationsStateKey);

export const selectNotificationsState = createSelector(selectNotificationsFeature, (state) => state);
